

const ApplicationTwo = ({ tertiary }) => {
    
    return ( 
        <table className="mt-4">
            <thead>
                <tr>
                    <th>Level Attained</th>
                    <th>Course Title</th>
                    <th>Year Obtained</th>
                </tr>
                </thead>
                <tbody>
                    {
                        tertiary && tertiary.map(item => (
                            <tr key={item.course}>
                                <td>{item.tertiaryLevel}</td>
                                <td>{item.course}</td>
                                <td>{item.tertiaryYear}</td>
                            </tr>
                        ))
                    }             
            </tbody>
        </table>
     );
}
 
export default ApplicationTwo;